import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DashboardPanel } from '../../shared/ui';

interface AppLoadingStateProps {
  label: string;
}

const LoadingPanel = styled(DashboardPanel)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export function AppLoadingState({ label }: AppLoadingStateProps) {
  return (
    <LoadingPanel panelVariant="surface">
      <Typography>{label}</Typography>
    </LoadingPanel>
  );
}
